import React from "react";
import TriloChatStudySelector from "./TriloChatStudySelector";
import { DocxIcon } from "./TriloChatIcons";
import { DEFAULT_SESSION_TITLE } from "../utils/triloChatConstants";
import { NO_PERMISSION_TITLE } from "../utils/permissions";

/**
 * TriloChatHeader
 *
 * Header of the open conversation: its title, the PDF export action and the
 * study context the session is bound to.
 *
 * Props:
 * - title: Session title (falls back to "New chat")
 * - canExport: Whether there is anything to export yet
 * - isExporting: Whether a PDF is currently being rendered
 * - onExport: () => void
 * - studies: Array of { id, name }
 * - selectedStudyId: Study context of this session, or ""
 * - onStudyChange: (studyId: string) => void
 * - canDownload: mw:downloads:read - whether the export action is usable
 */
const TriloChatHeader = ({
  title,
  canExport,
  isExporting,
  onExport,
  studies,
  selectedStudyId,
  onStudyChange,
  canDownload = true,
}) => (
  <div className="trilochat__chat-header">
    <h2>{title || DEFAULT_SESSION_TITLE}</h2>
    <div className="trilochat__chat-header-right">
      {canExport && (
        <button
          className="trilochat__export-btn"
          onClick={onExport}
          disabled={isExporting || !canDownload}
          title={canDownload ? undefined : NO_PERMISSION_TITLE}>
          <DocxIcon /> {isExporting ? "Generating…" : "Export PDF"}
        </button>
      )}
      <TriloChatStudySelector
        label="Study"
        studies={studies}
        selectedStudyId={selectedStudyId}
        onChange={onStudyChange}
      />
    </div>
  </div>
);

export default TriloChatHeader;
